import { OnLoadAction } from './action'
import { Component } from './components'
import { PRESCRIPTION_FULFILLMENT_OPTION } from './consultation'

export enum STEP_TYPE {
  USER_FORM = 'USER_FORM', // Save form values into user object
  CHOICES = 'CHOICES', // Save form values into choices array
  DEFAULT = 'DEFAULT', // Data is not saved,
  CONSULTATION = 'CONSULTATION',
  INDICATION_SURVEY = 'INDICATION_SURVEY', // Save data to indicationSurvey object
  FULFILLMENT_CHOICE_SELECTION = 'FULFILLMENT_CHOICE_SELECTION',
  NAVIGATOR = 'NAVIGATOR'
}

export enum BACK_TYPE {
  SHORT = 'SHORT', // Button without text
  LONG = 'LONG' // Button with text
}

export type Step = {
  id: string
  name: string
  components: { [id: string]: Component }
  componentsOrder: string[] // order of components
  backButton?: BACK_TYPE // Default is no back button
} & (
  | {
      type: STEP_TYPE.USER_FORM | STEP_TYPE.CHOICES | STEP_TYPE.DEFAULT | STEP_TYPE.CONSULTATION | STEP_TYPE.INDICATION_SURVEY
      hideHeader?: boolean // Shown by default
      showFooter?: boolean // Hidden by default

      showLanguageSelector?: boolean // Default is false

      onLoadActions?: OnLoadAction[] // Actions to be executed when the step is loaded

      hideIfFilled?: boolean // Hide the component if every component was filled
    }
  | {
      type: STEP_TYPE.FULFILLMENT_CHOICE_SELECTION
      option: PRESCRIPTION_FULFILLMENT_OPTION | null
    }
  | {
      type: STEP_TYPE.NAVIGATOR
    }
)
